import * as React from "react";
const SvgRemove = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" {...props}><path d="M36 30.9a3.6 3.6 0 0 1-5.1 5L22 27.1l-8.9 8.8a3.6 3.6 0 0 1-5-5l8.8-8.9-8.8-8.9a3.6 3.6 0 0 1 5-5l8.9 8.8 8.9-8.8a3.6 3.6 0 0 1 5 5L27.1 22z" /></svg>;
export default SvgRemove;